import { motion } from "framer-motion";
import { useIsMobile } from "@/hooks/use-mobile";

interface OrganicBlobProps {
  className?: string;
  color?: string;
  size?: string;
  duration?: number;
  delay?: number;
  blur?: string;
}

export default function OrganicBlob({
  className = "",
  color = "hsl(160, 40%, 80%)",
  size = "400px",
  duration = 8,
  delay = 0,
  blur = "80px",
}: OrganicBlobProps) {
  const isMobile = useIsMobile();

  // Mobile: render a static, low-blur blob — no animation, no expensive filter
  if (isMobile) {
    return (
      <div
        className={`absolute rounded-[60%_40%_30%_70%/60%_30%_70%_40%] pointer-events-none ${className}`}
        style={{
          width: size,
          height: size,
          background: color,
          filter: `blur(24px)`,
          opacity: 0.45,
          willChange: "auto",
        }}
        aria-hidden
      />
    );
  }

  return (
    <motion.div
      className={`absolute rounded-[60%_40%_30%_70%/60%_30%_70%_40%] pointer-events-none ${className}`}
      style={{
        width: size,
        height: size,
        background: color,
        filter: `blur(${blur})`,
        opacity: 0,
      }}
      animate={{
        opacity: [0.35, 0.6, 0.35],
        borderRadius: [
          "60% 40% 30% 70% / 60% 30% 70% 40%",
          "30% 70% 70% 30% / 30% 50% 50% 70%",
          "70% 30% 50% 50% / 40% 60% 40% 60%",
          "60% 40% 30% 70% / 60% 30% 70% 40%",
        ],
        scale: [1, 1.04, 0.97, 1],
      }}
      transition={{
        duration,
        delay,
        repeat: Infinity,
        ease: "easeInOut",
      }}
    />
  );
}
